import common from './common';
import feed from './feed';
import address from './address';
import store from './store';
import coupon from './coupon';
import bill from './bill';
import cart from './cart';
import pay from './pay';
import afterSales from './afterSales';
import order from './order';
import act from './act';
import user from './user';
import entrega from './entrega';

export default {
  common,
  feed,
  address,
  store,
  coupon,
  bill,
  cart,
  pay,
  afterSales,
  order,
  act,
  user,
  entrega,
};
